import "vuejs-noty/dist/vuejs-noty.css";

// plugins
import Vue from "vue";
import "@/plugins/dayjs.js";
import App from "./App.vue";
import axios from "axios";
import store from "./store";
import router from "./router";
import VueNoty from "vuejs-noty";
import notyOptions from "@/plugins/notyOptions";
import Vuelidate from "vuelidate";
import vuetify from "@/plugins/vuetify.js";
import i18n from "@/plugins/i18n.js";
import { EventBus } from "@/tools/event-bus";
import "@/tools/filters.js";
import "@/plugins/vueQuery.js";

Vue.use(Vuelidate);
Vue.use(VueNoty, notyOptions);
Vue.config.productionTip = false;

// Init axios configuration
axios.defaults.headers.common["Authorization"] =
  "Bearer " + store.state.security.token;

if (store.state.impersonate) {
  axios.defaults.headers.common["x-switch-user"] =
    store.state.impersonate.username;
}

axios.defaults.baseURL = process.env.VUE_APP_KRONOS_API;

import "./assets/css/app.css";

axios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (
      "response" in error &&
      (error.response.status === 401 ||
        error.response.status === 403 ||
        (error.response.status === 400 &&
          "error" in error.response.data &&
          error.response.data.error === "invalid_grant"))
    ) {
      EventBus.$emit("401-error");
    }

    return Promise.reject(error);
  }
);

window.addEventListener("keydown", function (e) {
  if (e.code === "Escape") {
    EventBus.$emit("key-abort");
  }
});

new Vue({
  el: "#app",
  store,
  router,
  vuetify,
  i18n,
  render: (h) => h(App),
});
